// Adresse et navigation du panneau de détail d'une liste de leads (kit carte
// lead, PER-2448). Les onglets sont fournis par la page qui utilise le kit ;
// le premier de la liste est l'onglet par défaut. Fonctions pures, testées
// avec Jest.

export const ongletParDefaut = (onglets = []) => (onglets[0] ? onglets[0].id : "infos");

export const estOnglet = (id, onglets = []) => onglets.some((o) => o.id === id);

// L'adresse porte le panneau ouvert : #panneau=<identifiant du lead>:<onglet>.
// Un rechargement ou un lien collé rouvre le même lead sur le même onglet.
const PREFIXE = "panneau=";

export function lirePanneauDepuisHash(hash = "", onglets = []) {
  const valeur = String(hash || "").replace(/^#/, "");
  if (!valeur.startsWith(PREFIXE)) return null;
  const [leadId, onglet] = valeur.slice(PREFIXE.length).split(":");
  if (!leadId) return null;
  return {
    leadId: decodeURIComponent(leadId),
    onglet: estOnglet(onglet, onglets) ? onglet : ongletParDefaut(onglets),
  };
}

export function ecrireHashPanneau(leadId, onglet, onglets = []) {
  const retenu = estOnglet(onglet, onglets) ? onglet : ongletParDefaut(onglets);
  return `#${PREFIXE}${encodeURIComponent(leadId)}:${retenu}`;
}

// Lead voisin dans l'ordre de la liste (delta -1 ou +1), null en bout de liste.
export function leadVoisin(ids = [], leadId, delta) {
  const i = ids.indexOf(leadId);
  if (i === -1) return null;
  const j = i + delta;
  return j >= 0 && j < ids.length ? ids[j] : null;
}
